import { createSelector } from "@reduxjs/toolkit";
import {
  IResult,
  ITrackingProperties,
  ExperiencesEntryProperties,
} from "redmond";
import { IStoreState } from "../../../../reducers/types";
import { getRewardsAccounts } from "../../../rewards/reducer";

export const getLocation = (state: IStoreState): IResult | null =>
  state.experiencesSearch.location;

export const getLocationCategories = (state: IStoreState) =>
  state.experiencesSearch.locationCategories;

export const getLocationCategoriesLoading = (state: IStoreState) =>
  state.experiencesSearch.locationCategoriesLoading;

export const getHasLocationAutocompleteError = (state: IStoreState) =>
  state.experiencesSearch.hasLocationAutocompleteError;

export const getFromDate = (state: IStoreState) =>
  state.experiencesSearch.fromDate;

export const getUntilDate = (state: IStoreState) =>
  state.experiencesSearch.untilDate;

export const getCategoryTagId = (state: IStoreState) =>
  state.experiencesSearch.categoryTagId;

export const getExperiencesEntryProperties = createSelector(
  getRewardsAccounts,
  (rewardsAccounts): ITrackingProperties<ExperiencesEntryProperties> => ({
    properties: {
      rewards_accounts: rewardsAccounts
        .map((r) => r.productDisplayName)
        .join(","),
    },
    encryptedProperties: [],
  })
);
